import { Collapse, Grid, TextField, Typography, Button } from "@mui/material"
import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import axios from "axios"
import { LoadingButton } from "@mui/lab"
import usePersonAuthStore from "../../../store/personAuthStore"
type DualAuthProps = {
    tempId: string | null;
}
const DualAuth = ({ tempId }: DualAuthProps) => {
    const [oneTimeCode, setOneTimeCode] = useState(Array.from({ length: 6 }, () => ''))
    const [submitting, setSubmitting] = useState({
        codeSubmit: false,
        resendEmail: false
    })
    const [seconds, setSeconds] = useState<number>(30)
    const [error, setError] = useState('')
    const [showError, setShowError] = useState(false)
    const setPersonAuthToken = usePersonAuthStore(state => state.setAuthValues)
    const navigate = useNavigate()
    useEffect(() => {
        const interval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1)
            }
        }, 1000)
        return () => {
            clearInterval(interval)
        }
    }, [seconds])
    const handleChange = (index: number, e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value
        const tempCode = [...oneTimeCode]
        tempCode[index] = value
        setOneTimeCode(tempCode)
        // NOTE: THIS IS TO AUTO ADVANCE TO THE NEXT BOX
        if (value && index < oneTimeCode.length - 1) {
            const nextElement = document.getElementById(`digit-${index + 1}`)
            if (nextElement) {
                nextElement.focus()
            }
        } else if (!value && index > 0) {
            const prevElement = document.getElementById(`digit-${index - 1}`)
            if (prevElement) {
                prevElement.focus()
            }
        }
    }

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        try {
            setSubmitting({ ...submitting, codeSubmit: true })
            await axios.post(`${window.__env.API_URL}/api/oauth/verify-onetimecode`,
                {
                    userId: tempId, OneTimeCode: oneTimeCode.join('')
                },
                {
                    withCredentials: true,
                    headers: { "access-control-allow-origin": "*" }
                }).then(async (res: any) => {
                    if (res.status >= 400) {
                        const { Message } = await res.data
                        throw new Error(Message)
                    } else {
                        return res.data
                    }
                }).then((data) => {
                    setSubmitting({ ...submitting, codeSubmit: false })
                    setPersonAuthToken(data)
                    navigate("/dashboard", { replace: true })

                }).catch(function (error) {
                    if (error.message) {
                        setError(error.message)
                    }
                    setSubmitting({ ...submitting, codeSubmit: false })
                    setShowError(true)
                })
        } catch (e) {
        }
    }
    const resendEmail = async (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault()
        setSeconds(30)
        try {
            setSubmitting({ ...submitting, resendEmail: true })
            await axios.post(`${window.__env.API_URL}/api/oauth/resend-onetimecode`, {
                UserId: tempId
            },
                {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "application/json",
                        "access-control-allow-origin": "*"
                    }
                }).then(async (res) => {
                    // TODO: WHAT DO HERE?
                })
        } catch (e) {
            return null
        }
    }
    return (
        <Grid container spacing={2}>
            <Grid size={12} style={{
                marginTop: "40px",
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "center",
            }}>
                <div style={{ height: "175px", width: "500px", background: `url(${process.env.PUBLIC_URL}/assets/images/logos/FT_logo_1.png)`, backgroundSize: "contain", backgroundRepeat: "no-repeat", backgroundPosition: "center" }}></div>

            </Grid>
            <Grid size={12}
                style={{
                    height: "400px",
                    padding: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2} style={{ maxWidth: "400px" }}>
                        <Grid size={12} sx={{ textAlign: "center" }}>
                            <Typography>We sent just sent a code to the email on file, please enter it below</Typography>
                        </Grid>
                        {oneTimeCode.map((digit, index) => (
                            <Grid size={2}>
                                <TextField
                                    autoComplete="off"
                                    key={index}
                                    type='text'
                                    inputProps={{
                                        maxLength: 1,
                                        style: { textAlign: "center" }
                                    }}
                                    size="medium"
                                    value={digit}
                                    id={`digit-${index}`}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(index, e)}
                                />
                            </Grid>
                        ))}
                        <Grid size={12} sx={{ textAlign: "center" }}>
                            <Collapse in={showError}>
                                <Typography>{error}</Typography>
                            </Collapse>
                            {submitting.codeSubmit ?
                                (<LoadingButton loading={submitting.codeSubmit} sx={{ marginTop: "32px" }} variant="contained">Submit</LoadingButton>) :
                                (<Button type="submit" variant='contained' disabled={oneTimeCode.some(item => item === '')} >Submit</Button>)
                            }
                        </Grid>
                        <Grid size={12} sx={{ textAlign: "center" }}>
                            <Typography>Didn't receive an email?</Typography>
                            <Button onClick={resendEmail} disabled={seconds > 0}>Resend Code {seconds > 0 ? `in ${seconds} seconds` : ''}</Button>
                        </Grid>
                    </Grid >
                </form>
            </Grid>
        </Grid>
    )
}

export default DualAuth